export const PASSWORD_MIN_LENGTH = 15
export const PASSWORD_MAX_LENGTH = 64

const SEQUENCES = [
  '1234', '2345', '3456', '4567', '5678', '6789', '7890', '0123',
  'abcd', 'bcde', 'cdef', 'defg', 'efgh', 'fghi', 'ghij', 'hijk',
  'ijkl', 'jklm', 'klmn', 'lmno', 'mnop', 'nopq', 'opqr', 'pqrs',
  'qrst', 'rstu', 'stuv', 'tuvw', 'uvwx', 'vwxy', 'wxyz',
  'qwer', 'asdf', 'zxcv',
]

const toLowerString = (value) => String(value ?? '').trim().toLowerCase()

const emailPrefix = (email) => {
  const prefix = toLowerString(email).split('@')[0] ?? ''

  return prefix.length > 3 ? prefix : ''
}

const personalValue = (value, minLength) => {
  const normalized = toLowerString(value)

  return normalized.length > minLength ? normalized : ''
}

export function evaluatePassword(password, context = {}) {
  const value = String(password ?? '')
  const lowerValue = value.toLowerCase()
  const personalValues = [
    emailPrefix(context.email),
    personalValue(context.firstName, 2),
    personalValue(context.lastName, 2),
    ...(context.additionalPersonalValues || []).map((item) => personalValue(item, 2)),
  ].filter(Boolean)

  return {
    hasMinLength: value.length >= PASSWORD_MIN_LENGTH,
    hasMaxLength: value.length <= PASSWORD_MAX_LENGTH,
    hasPrintableAsciiOnly: /^[\x20-\x7E]*$/.test(value),
    hasNoSequentialCharacters: !SEQUENCES.some((sequence) => lowerValue.includes(sequence)),
    hasNoRepeatedCharacters: !/(.)\1+/.test(value),
    hasNoPlatformName: !lowerValue.includes('remoni'),
    hasNoPersonalData: !personalValues.some((item) => lowerValue.includes(item)),
  }
}

export function isPasswordValid(password, context = {}) {
  return Object.values(evaluatePassword(password, context)).every(Boolean)
}
